module.exports = __webpack_public_path__ + "ce980c9e47d3b011ef389a6dc00894e0.png";